import React, { useState } from 'react';
import { api } from '../api/client';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setMessage('');
    try {
      const res = await api.post('/auth/forgot-password', { email: email.trim() });
      setMessage(res.data?.message || 'If the address exists, an email will be sent.');
    } catch (err: any) {
      setMessage(err.response?.data?.message || 'If the address exists, an email will be sent.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container mt-5" role="main">
      <h2>Forgot Password</h2>
      <p className="text-muted">Enter your email to receive a password reset link. The link expires in 60 minutes.</p>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="emailInput" className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            id="emailInput"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={busy}>
          {busy ? 'Sending…' : 'Send Reset Link'}
        </button>
      </form>
      {message && <p className="mt-3" aria-live="polite">{message}</p>}
    </div>
  );
};

export default ForgotPassword;

